import { useMemo } from 'react';
import useIsSale from '../../Common/_hooks/useIsSale';
import { productCatalogCollections } from '../Collections';
import { isProductCatalogCollectionActive } from '../Collections/ProductCatalogCollection';

export default function useProductCatalogCollections() {
  const isSale = useIsSale();

  return useMemo(() => {
    return productCatalogCollections.filter(collection => {
      return isProductCatalogCollectionActive(collection, { isSale });
    });
  }, [isSale]);
}
